// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMAlertsModule-module__font-s-10___yka3V {
  font-size: 10px !important;
}

.CGMAlertsModule-module__font-s-12___iQe_n {
  font-size: 12px !important;
}

.CGMAlertsModule-module__font-s-13___HE_6L {
  font-size: 13px !important;
}

.CGMAlertsModule-module__font-s-14___VkRE5 {
  font-size: 14px !important;
}

.CGMAlertsModule-module__font-s-15___p5CpM {
  font-size: 15px !important;
}

.CGMAlertsModule-module__font-s-16___xgb4L {
  font-size: 16px !important;
}

.CGMAlertsModule-module__font-s-18___MRKx8 {
  font-size: 18px !important;
}

.CGMAlertsModule-module__font-s-20___EM2ZL {
  font-size: 20px !important;
}

.CGMAlertsModule-module__font-s-22___bJdnr {
  font-size: 22px !important;
}

.CGMAlertsModule-module__font-s-28___CmBtZ {
  font-size: 28px !important;
}

.CGMAlertsModule-module__font-w-400___L6SWg {
  font-weight: 400 !important;
}

.CGMAlertsModule-module__font-w-500___KWpEO {
  font-weight: 500 !important;
}

.CGMAlertsModule-module__font-w-600___CoUrG {
  font-weight: 600 !important;
}

.CGMAlertsModule-module__font-w-700___rKN74 {
  font-weight: 700 !important;
}

.CGMAlertsModule-module__p-5___bl14K {
  padding: 5px !important;
}

.CGMAlertsModule-module__p-12___UTu3W {
  padding: 12px !important;
}

.CGMAlertsModule-module__p-16___aQZpF {
  padding: 16px !important;
}

.CGMAlertsModule-module__p-30___EC8SV {
  padding: 30px !important;
}

.CGMAlertsModule-module__p-b-0___h6L5B {
  padding-bottom: 0 !important;
}

.CGMAlertsModule-module__p-b-5___KapEK {
  padding-bottom: 5px !important;
}

.CGMAlertsModule-module__p-b-10___jYRdG {
  padding-bottom: 10px !important;
}

.CGMAlertsModule-module__p-b-12___OzThK {
  padding-bottom: 12px !important;
}

.CGMAlertsModule-module__p-b-16___S8bEC {
  padding-bottom: 16px !important;
}

.CGMAlertsModule-module__p-b-18___AZVzo {
  padding-bottom: 18px !important;
}

.CGMAlertsModule-module__p-b-20___znEAi {
  padding-bottom: 20px !important;
}

.CGMAlertsModule-module__p-b-25___eJjVm {
  padding-bottom: 25px !important;
}

.CGMAlertsModule-module__p-b-30___UvNBo {
  padding-bottom: 30px !important;
}

.CGMAlertsModule-module__p-b-50___xvkYb {
  padding-bottom: 50px !important;
}

.CGMAlertsModule-module__p-t-0___8syar {
  padding-top: 0 !important;
}

.CGMAlertsModule-module__p-t-12___n4tDq {
  padding-top: 12px !important;
}

.CGMAlertsModule-module__p-t-16___vxsdC {
  padding-top: 16px !important;
}

.CGMAlertsModule-module__p-t-18___z8o94 {
  padding-top: 18px !important;
}

.CGMAlertsModule-module__p-t-20___qaAsz {
  padding-top: 20px !important;
}

.CGMAlertsModule-module__p-t-30___gxws5 {
  padding-top: 30px !important;
}

.CGMAlertsModule-module__p-t-40___vEfRC {
  padding-top: 40px !important;
}

.CGMAlertsModule-module__p-t-50___STlGN {
  padding-top: 50px !important;
}

.CGMAlertsModule-module__p-l-20___Ayk1N {
  padding-left: 20px !important;
}

.CGMAlertsModule-module__p-l-30___T4Ica {
  padding-left: 30px !important;
}

.CGMAlertsModule-module__p-l-40___lrW8A {
  padding-left: 40px !important;
}

.CGMAlertsModule-module__p-r-16___QBVaP {
  padding-right: 16px !important;
}

.CGMAlertsModule-module__p-r-20___MtrO6 {
  padding-right: 20px !important;
}

.CGMAlertsModule-module__p-r-30___eELgw {
  padding-right: 30px !important;
}

.CGMAlertsModule-module__p-r-50___kgoj2 {
  padding-right: 50px !important;
}

.CGMAlertsModule-module__p-r-60___kwIeH {
  padding-right: 60px !important;
}

.CGMAlertsModule-module__m-b-1___iCWIW {
  margin-bottom: 1px !important;
}

.CGMAlertsModule-module__m-b-2___hsDpu {
  margin-bottom: 2px !important;
}

.CGMAlertsModule-module__m-b-6___URDMG {
  margin-bottom: 6px !important;
}

.CGMAlertsModule-module__m-b-8___djA8k {
  margin-bottom: 8px !important;
}

.CGMAlertsModule-module__m-b-10___zkrEl {
  margin-bottom: 10px !important;
}

.CGMAlertsModule-module__m-b-14___nrHZF {
  margin-bottom: 14px !important;
}

.CGMAlertsModule-module__m-b-16___iKijU {
  margin-bottom: 16px !important;
}

.CGMAlertsModule-module__m-b-20___bKrmM {
  margin-bottom: 20px !important;
}

.CGMAlertsModule-module__m-b-22___ncohO {
  margin-bottom: 22px !important;
}

.CGMAlertsModule-module__m-b-24___WhVBz {
  margin-bottom: 24px !important;
}

.CGMAlertsModule-module__m-b-30___R0TGK {
  margin-bottom: 30px !important;
}

.CGMAlertsModule-module__m-b-32___H65X6 {
  margin-bottom: 32px !important;
}

.CGMAlertsModule-module__m-b-40___SK97t {
  margin-bottom: 40px !important;
}

.CGMAlertsModule-module__m-t-2___LB_av {
  margin-top: 2px !important;
}

.CGMAlertsModule-module__m-t-3___svH5q {
  margin-top: 3px !important;
}

.CGMAlertsModule-module__m-t-4___qZ8KF {
  margin-top: 4px !important;
}

.CGMAlertsModule-module__m-t-5___Uw4NT {
  margin-top: 5px !important;
}

.CGMAlertsModule-module__m-t-8___o3tTx {
  margin-top: 8px !important;
}

.CGMAlertsModule-module__m-t-10___kE1wi {
  margin-top: 10px !important;
}

.CGMAlertsModule-module__m-t-15___SpRRD {
  margin-top: 15px !important;
}

.CGMAlertsModule-module__m-t-16___Tx7jo {
  margin-top: 16px !important;
}

.CGMAlertsModule-module__m-t-20___Z4AUK {
  margin-top: 20px !important;
}

.CGMAlertsModule-module__m-t-22___TZLbe {
  margin-top: 22px !important;
}

.CGMAlertsModule-module__m-t-30___ba3Ge {
  margin-top: 30px !important;
}

.CGMAlertsModule-module__m-t-32___L7zpy {
  margin-top: 32px !important;
}

.CGMAlertsModule-module__m-l-auto___QKCMO {
  margin-left: auto !important;
}

.CGMAlertsModule-module__m-l-4___HPiM3 {
  margin-left: 4px !important;
}

.CGMAlertsModule-module__m-l-5___pV8C3 {
  margin-left: 5px !important;
}

.CGMAlertsModule-module__m-l-6___sby1s {
  margin-left: 6px !important;
}

.CGMAlertsModule-module__m-l-8___lN5jH {
  margin-left: 8px !important;
}

.CGMAlertsModule-module__m-l-10___e19LW {
  margin-left: 10px !important;
}

.CGMAlertsModule-module__m-l-16___rmDsK {
  margin-left: 16px !important;
}

.CGMAlertsModule-module__m-l-20___NAttK {
  margin-left: 20px !important;
}

.CGMAlertsModule-module__m-l-24___Nwl50 {
  margin-left: 24px !important;
}

.CGMAlertsModule-module__m-l-30___uYyG8 {
  margin-left: 30px !important;
}

.CGMAlertsModule-module__m-l-35___H_r55 {
  margin-left: 35px !important;
}

.CGMAlertsModule-module__m-l-40___fdEmf {
  margin-left: 40px !important;
}

.CGMAlertsModule-module__m-r-8___v62om {
  margin-right: 8px !important;
}

.CGMAlertsModule-module__m-r-10___T1nEx {
  margin-right: 10px !important;
}

.CGMAlertsModule-module__m-r-16___Xh8hN {
  margin-right: 16px !important;
}

.CGMAlertsModule-module__m-r-20___xPqLm {
  margin-right: 20px !important;
}

.CGMAlertsModule-module__m-r-24___gmxck {
  margin-right: 24px !important;
}

.CGMAlertsModule-module__m-r-30___AtgXB {
  margin-right: 30px !important;
}

.CGMAlertsModule-module__m-r-40___UlTrv {
  margin-right: 40px !important;
}

.CGMAlertsModule-module__border-r-3___Fxzji {
  border-radius: 3px !important;
}

.CGMAlertsModule-module__border-r-4___vkqTF {
  border-radius: 4px !important;
}

.CGMAlertsModule-module__border-r-6___fNB4Y {
  border-radius: 6px !important;
}

.CGMAlertsModule-module__border-r-10___aC7rU {
  border-radius: 10px !important;
}

.CGMAlertsModule-module__border-r-12___oEdOg {
  border-radius: 12px !important;
}

.CGMAlertsModule-module__border-r-16___WY4Jo {
  border-radius: 16px !important;
}

.CGMAlertsModule-module__border-r-50___F4Md9 {
  border-radius: 50% !important;
}

.CGMAlertsModule-module__primary-border___wpNiS {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAlertsModule-module__primary-border-b___gSE7D {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAlertsModule-module__primary-border-t___UVteo {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAlertsModule-module__primary-border-l___ROeIU {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAlertsModule-module__primary-border-r___n7lcT {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAlertsModule-module__secondary-border___OhPsg {
  border: 1px solid #637768;
}

.CGMAlertsModule-module__secondary-border-b___id033 {
  border-bottom: 1px solid #637768;
}

.CGMAlertsModule-module__secondary-border-t___nDv7H {
  border-top: 1px solid #637768;
}

.CGMAlertsModule-module__secondary-border-l___vmFMX {
  border-left: 1px solid #637768;
}

.CGMAlertsModule-module__secondary-border-r____KPdN {
  border-right: 1px solid #637768;
}

.CGMAlertsModule-module__gap-0___UV4K8 {
  gap: 0 !important;
}

.CGMAlertsModule-module__gap-2___CKRlc {
  gap: 2px !important;
}

.CGMAlertsModule-module__gap-4___j0IT3 {
  gap: 4px !important;
}

.CGMAlertsModule-module__gap-5___GlWRg {
  gap: 5px !important;
}

.CGMAlertsModule-module__gap-6___A3MKH {
  gap: 6px !important;
}

.CGMAlertsModule-module__gap-8___geV5y {
  gap: 8px !important;
}

.CGMAlertsModule-module__gap-10____aP5a {
  gap: 10px !important;
}

.CGMAlertsModule-module__gap-12___KAG8n {
  gap: 12px !important;
}

.CGMAlertsModule-module__gap-14___4y6Au {
  gap: 14px !important;
}

.CGMAlertsModule-module__gap-16___da2YS {
  gap: 16px !important;
}

.CGMAlertsModule-module__gap-18___RBXhq {
  gap: 18px !important;
}

.CGMAlertsModule-module__gap-20___JdgVl {
  gap: 20px !important;
}

.CGMAlertsModule-module__gap-24___t6u79 {
  gap: 24px !important;
}

.CGMAlertsModule-module__gap-26___PIPrp {
  gap: 26px !important;
}

.CGMAlertsModule-module__gap-30___IU1qj {
  gap: 30px !important;
}

.CGMAlertsModule-module__gap-32___dCqyS {
  gap: 32px !important;
}

.CGMAlertsModule-module__gap-40___wWplX {
  gap: 40px !important;
}

.CGMAlertsModule-module__gap-50___Q1J3s {
  gap: 50px !important;
}

.CGMAlertsModule-module__flex-1___xcmhU {
  flex: 1;
}

.CGMAlertsModule-module__flex-none___v059B {
  flex: none !important;
}

.CGMAlertsModule-module__flex-column____ZWSN {
  display: flex;
  flex-direction: column !important;
}

.CGMAlertsModule-module__flex-row___j7clG {
  display: flex;
  flex-direction: row !important;
}

.CGMAlertsModule-module__vertically-centered___hGpUs {
  display: flex;
  align-items: center !important;
}

.CGMAlertsModule-module__horizontally-centered___NvMxb {
  display: flex;
  justify-content: center !important;
}

.CGMAlertsModule-module__horizontally-end___AmznV {
  display: flex;
  justify-content: end !important;
}

.CGMAlertsModule-module__vertically-start___DvI0w {
  display: flex;
  align-items: start !important;
}

.CGMAlertsModule-module__space-between___xaj1x {
  display: flex;
  justify-content: space-between !important;
}

.CGMAlertsModule-module__flex-wrap___UeJWs {
  flex-wrap: wrap !important;
}

.CGMAlertsModule-module__height-100___VTZaY {
  height: 100%;
}

.CGMAlertsModule-module__width-50___lU_Ht {
  width: 50% !important;
}

.CGMAlertsModule-module__width-100___Vb5fB {
  width: 100%;
}

.CGMAlertsModule-module__cursor-pointer___jTDPL {
  cursor: pointer;
}

.CGMAlertsModule-module__cursor-not-allowed___EuQMT {
  cursor: not-allowed !important;
}

.CGMAlertsModule-module__absolute-centered___AzIfy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMAlertsModule-module__absolute___EOuH5 {
  position: absolute;
}

.CGMAlertsModule-module__relative___hvsTa {
  position: relative;
}

.CGMAlertsModule-module__fixed___ulPO2 {
  position: fixed;
}

.CGMAlertsModule-module__visible___UsuEB {
  opacity: 1;
}

.CGMAlertsModule-module__invisible___nv1T_ {
  opacity: 0;
}

.CGMAlertsModule-module__col-90___BQ2Xo {
  width: 90% !important;
}

.CGMAlertsModule-module__col-auto___unosW {
  width: auto !important;
}

.CGMAlertsModule-module__medical-tabs___c2oR7 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMAlertsModule-module__medical-table-new___F3Uqr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr::-webkit-scrollbar-track {
  display: none;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr.CGMAlertsModule-module__no-pagination___AZlr2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr.CGMAlertsModule-module__no-pagination___AZlr2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr.CGMAlertsModule-module__no-pagination___AZlr2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMAlertsModule-module__medical-table-new___F3Uqr.CGMAlertsModule-module__no-pagination___AZlr2::-webkit-scrollbar-track {
  display: none;
}

.CGMAlertsModule-module__medical-table-empty___YPZzp {
  padding: 14px 40px !important;
}

.CGMAlertsModule-module__icon-btn___YyjFG {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMAlertsModule-module__search-icon___VaxIQ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMAlertsModule-module__disable-select___pJ8iM {
  user-select: none;
}

.CGMAlertsModule-module__break-word___J1QVz {
  word-break: break-word;
}

.CGMAlertsModule-module__popup-clear-btn___qwFBi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMAlertsModule-module__scroll-m-b-20___vl7GD {
  scroll-margin-bottom: 20px;
}

.CGMAlertsModule-module__container___mZs1d {
  color: #375844;
  padding: 14px 30px 0 0;
}
.CGMAlertsModule-module__container___mZs1d .CGMAlertsModule-module__input___SCPbH {
  min-width: 250px;
  width: 66%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/CGMAlertsModule/CGMAlertsModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,sBAAA;AA8pBF;AA5pBE;EACE,gBAAA;EACA,UAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  padding: 14px 30px 0 0;\n\n  .input {\n    min-width: 250px;\n    width: 66%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMAlertsModule-module__font-s-10___yka3V`,
	"fontS12": `CGMAlertsModule-module__font-s-12___iQe_n`,
	"fontS13": `CGMAlertsModule-module__font-s-13___HE_6L`,
	"fontS14": `CGMAlertsModule-module__font-s-14___VkRE5`,
	"fontS15": `CGMAlertsModule-module__font-s-15___p5CpM`,
	"fontS16": `CGMAlertsModule-module__font-s-16___xgb4L`,
	"fontS18": `CGMAlertsModule-module__font-s-18___MRKx8`,
	"fontS20": `CGMAlertsModule-module__font-s-20___EM2ZL`,
	"fontS22": `CGMAlertsModule-module__font-s-22___bJdnr`,
	"fontS28": `CGMAlertsModule-module__font-s-28___CmBtZ`,
	"fontW400": `CGMAlertsModule-module__font-w-400___L6SWg`,
	"fontW500": `CGMAlertsModule-module__font-w-500___KWpEO`,
	"fontW600": `CGMAlertsModule-module__font-w-600___CoUrG`,
	"fontW700": `CGMAlertsModule-module__font-w-700___rKN74`,
	"p5": `CGMAlertsModule-module__p-5___bl14K`,
	"p12": `CGMAlertsModule-module__p-12___UTu3W`,
	"p16": `CGMAlertsModule-module__p-16___aQZpF`,
	"p30": `CGMAlertsModule-module__p-30___EC8SV`,
	"pB0": `CGMAlertsModule-module__p-b-0___h6L5B`,
	"pB5": `CGMAlertsModule-module__p-b-5___KapEK`,
	"pB10": `CGMAlertsModule-module__p-b-10___jYRdG`,
	"pB12": `CGMAlertsModule-module__p-b-12___OzThK`,
	"pB16": `CGMAlertsModule-module__p-b-16___S8bEC`,
	"pB18": `CGMAlertsModule-module__p-b-18___AZVzo`,
	"pB20": `CGMAlertsModule-module__p-b-20___znEAi`,
	"pB25": `CGMAlertsModule-module__p-b-25___eJjVm`,
	"pB30": `CGMAlertsModule-module__p-b-30___UvNBo`,
	"pB50": `CGMAlertsModule-module__p-b-50___xvkYb`,
	"pT0": `CGMAlertsModule-module__p-t-0___8syar`,
	"pT12": `CGMAlertsModule-module__p-t-12___n4tDq`,
	"pT16": `CGMAlertsModule-module__p-t-16___vxsdC`,
	"pT18": `CGMAlertsModule-module__p-t-18___z8o94`,
	"pT20": `CGMAlertsModule-module__p-t-20___qaAsz`,
	"pT30": `CGMAlertsModule-module__p-t-30___gxws5`,
	"pT40": `CGMAlertsModule-module__p-t-40___vEfRC`,
	"pT50": `CGMAlertsModule-module__p-t-50___STlGN`,
	"pL20": `CGMAlertsModule-module__p-l-20___Ayk1N`,
	"pL30": `CGMAlertsModule-module__p-l-30___T4Ica`,
	"pL40": `CGMAlertsModule-module__p-l-40___lrW8A`,
	"pR16": `CGMAlertsModule-module__p-r-16___QBVaP`,
	"pR20": `CGMAlertsModule-module__p-r-20___MtrO6`,
	"pR30": `CGMAlertsModule-module__p-r-30___eELgw`,
	"pR50": `CGMAlertsModule-module__p-r-50___kgoj2`,
	"pR60": `CGMAlertsModule-module__p-r-60___kwIeH`,
	"mB1": `CGMAlertsModule-module__m-b-1___iCWIW`,
	"mB2": `CGMAlertsModule-module__m-b-2___hsDpu`,
	"mB6": `CGMAlertsModule-module__m-b-6___URDMG`,
	"mB8": `CGMAlertsModule-module__m-b-8___djA8k`,
	"mB10": `CGMAlertsModule-module__m-b-10___zkrEl`,
	"mB14": `CGMAlertsModule-module__m-b-14___nrHZF`,
	"mB16": `CGMAlertsModule-module__m-b-16___iKijU`,
	"mB20": `CGMAlertsModule-module__m-b-20___bKrmM`,
	"mB22": `CGMAlertsModule-module__m-b-22___ncohO`,
	"mB24": `CGMAlertsModule-module__m-b-24___WhVBz`,
	"mB30": `CGMAlertsModule-module__m-b-30___R0TGK`,
	"mB32": `CGMAlertsModule-module__m-b-32___H65X6`,
	"mB40": `CGMAlertsModule-module__m-b-40___SK97t`,
	"mT2": `CGMAlertsModule-module__m-t-2___LB_av`,
	"mT3": `CGMAlertsModule-module__m-t-3___svH5q`,
	"mT4": `CGMAlertsModule-module__m-t-4___qZ8KF`,
	"mT5": `CGMAlertsModule-module__m-t-5___Uw4NT`,
	"mT8": `CGMAlertsModule-module__m-t-8___o3tTx`,
	"mT10": `CGMAlertsModule-module__m-t-10___kE1wi`,
	"mT15": `CGMAlertsModule-module__m-t-15___SpRRD`,
	"mT16": `CGMAlertsModule-module__m-t-16___Tx7jo`,
	"mT20": `CGMAlertsModule-module__m-t-20___Z4AUK`,
	"mT22": `CGMAlertsModule-module__m-t-22___TZLbe`,
	"mT30": `CGMAlertsModule-module__m-t-30___ba3Ge`,
	"mT32": `CGMAlertsModule-module__m-t-32___L7zpy`,
	"mLAuto": `CGMAlertsModule-module__m-l-auto___QKCMO`,
	"mL4": `CGMAlertsModule-module__m-l-4___HPiM3`,
	"mL5": `CGMAlertsModule-module__m-l-5___pV8C3`,
	"mL6": `CGMAlertsModule-module__m-l-6___sby1s`,
	"mL8": `CGMAlertsModule-module__m-l-8___lN5jH`,
	"mL10": `CGMAlertsModule-module__m-l-10___e19LW`,
	"mL16": `CGMAlertsModule-module__m-l-16___rmDsK`,
	"mL20": `CGMAlertsModule-module__m-l-20___NAttK`,
	"mL24": `CGMAlertsModule-module__m-l-24___Nwl50`,
	"mL30": `CGMAlertsModule-module__m-l-30___uYyG8`,
	"mL35": `CGMAlertsModule-module__m-l-35___H_r55`,
	"mL40": `CGMAlertsModule-module__m-l-40___fdEmf`,
	"mR8": `CGMAlertsModule-module__m-r-8___v62om`,
	"mR10": `CGMAlertsModule-module__m-r-10___T1nEx`,
	"mR16": `CGMAlertsModule-module__m-r-16___Xh8hN`,
	"mR20": `CGMAlertsModule-module__m-r-20___xPqLm`,
	"mR24": `CGMAlertsModule-module__m-r-24___gmxck`,
	"mR30": `CGMAlertsModule-module__m-r-30___AtgXB`,
	"mR40": `CGMAlertsModule-module__m-r-40___UlTrv`,
	"borderR3": `CGMAlertsModule-module__border-r-3___Fxzji`,
	"borderR4": `CGMAlertsModule-module__border-r-4___vkqTF`,
	"borderR6": `CGMAlertsModule-module__border-r-6___fNB4Y`,
	"borderR10": `CGMAlertsModule-module__border-r-10___aC7rU`,
	"borderR12": `CGMAlertsModule-module__border-r-12___oEdOg`,
	"borderR16": `CGMAlertsModule-module__border-r-16___WY4Jo`,
	"borderR50": `CGMAlertsModule-module__border-r-50___F4Md9`,
	"primaryBorder": `CGMAlertsModule-module__primary-border___wpNiS`,
	"primaryBorderB": `CGMAlertsModule-module__primary-border-b___gSE7D`,
	"primaryBorderT": `CGMAlertsModule-module__primary-border-t___UVteo`,
	"primaryBorderL": `CGMAlertsModule-module__primary-border-l___ROeIU`,
	"primaryBorderR": `CGMAlertsModule-module__primary-border-r___n7lcT`,
	"secondaryBorder": `CGMAlertsModule-module__secondary-border___OhPsg`,
	"secondaryBorderB": `CGMAlertsModule-module__secondary-border-b___id033`,
	"secondaryBorderT": `CGMAlertsModule-module__secondary-border-t___nDv7H`,
	"secondaryBorderL": `CGMAlertsModule-module__secondary-border-l___vmFMX`,
	"secondaryBorderR": `CGMAlertsModule-module__secondary-border-r____KPdN`,
	"gap0": `CGMAlertsModule-module__gap-0___UV4K8`,
	"gap2": `CGMAlertsModule-module__gap-2___CKRlc`,
	"gap4": `CGMAlertsModule-module__gap-4___j0IT3`,
	"gap5": `CGMAlertsModule-module__gap-5___GlWRg`,
	"gap6": `CGMAlertsModule-module__gap-6___A3MKH`,
	"gap8": `CGMAlertsModule-module__gap-8___geV5y`,
	"gap10": `CGMAlertsModule-module__gap-10____aP5a`,
	"gap12": `CGMAlertsModule-module__gap-12___KAG8n`,
	"gap14": `CGMAlertsModule-module__gap-14___4y6Au`,
	"gap16": `CGMAlertsModule-module__gap-16___da2YS`,
	"gap18": `CGMAlertsModule-module__gap-18___RBXhq`,
	"gap20": `CGMAlertsModule-module__gap-20___JdgVl`,
	"gap24": `CGMAlertsModule-module__gap-24___t6u79`,
	"gap26": `CGMAlertsModule-module__gap-26___PIPrp`,
	"gap30": `CGMAlertsModule-module__gap-30___IU1qj`,
	"gap32": `CGMAlertsModule-module__gap-32___dCqyS`,
	"gap40": `CGMAlertsModule-module__gap-40___wWplX`,
	"gap50": `CGMAlertsModule-module__gap-50___Q1J3s`,
	"flex1": `CGMAlertsModule-module__flex-1___xcmhU`,
	"flexNone": `CGMAlertsModule-module__flex-none___v059B`,
	"flexColumn": `CGMAlertsModule-module__flex-column____ZWSN`,
	"flexRow": `CGMAlertsModule-module__flex-row___j7clG`,
	"verticallyCentered": `CGMAlertsModule-module__vertically-centered___hGpUs`,
	"horizontallyCentered": `CGMAlertsModule-module__horizontally-centered___NvMxb`,
	"horizontallyEnd": `CGMAlertsModule-module__horizontally-end___AmznV`,
	"verticallyStart": `CGMAlertsModule-module__vertically-start___DvI0w`,
	"spaceBetween": `CGMAlertsModule-module__space-between___xaj1x`,
	"flexWrap": `CGMAlertsModule-module__flex-wrap___UeJWs`,
	"height100": `CGMAlertsModule-module__height-100___VTZaY`,
	"width50": `CGMAlertsModule-module__width-50___lU_Ht`,
	"width100": `CGMAlertsModule-module__width-100___Vb5fB`,
	"cursorPointer": `CGMAlertsModule-module__cursor-pointer___jTDPL`,
	"cursorNotAllowed": `CGMAlertsModule-module__cursor-not-allowed___EuQMT`,
	"absoluteCentered": `CGMAlertsModule-module__absolute-centered___AzIfy`,
	"absolute": `CGMAlertsModule-module__absolute___EOuH5`,
	"relative": `CGMAlertsModule-module__relative___hvsTa`,
	"fixed": `CGMAlertsModule-module__fixed___ulPO2`,
	"visible": `CGMAlertsModule-module__visible___UsuEB`,
	"invisible": `CGMAlertsModule-module__invisible___nv1T_`,
	"col90": `CGMAlertsModule-module__col-90___BQ2Xo`,
	"colAuto": `CGMAlertsModule-module__col-auto___unosW`,
	"medicalTabs": `CGMAlertsModule-module__medical-tabs___c2oR7`,
	"medicalTableNew": `CGMAlertsModule-module__medical-table-new___F3Uqr`,
	"noPagination": `CGMAlertsModule-module__no-pagination___AZlr2`,
	"medicalTableEmpty": `CGMAlertsModule-module__medical-table-empty___YPZzp`,
	"iconBtn": `CGMAlertsModule-module__icon-btn___YyjFG`,
	"searchIcon": `CGMAlertsModule-module__search-icon___VaxIQ`,
	"disableSelect": `CGMAlertsModule-module__disable-select___pJ8iM`,
	"breakWord": `CGMAlertsModule-module__break-word___J1QVz`,
	"popupClearBtn": `CGMAlertsModule-module__popup-clear-btn___qwFBi`,
	"scrollMB20": `CGMAlertsModule-module__scroll-m-b-20___vl7GD`,
	"container": `CGMAlertsModule-module__container___mZs1d`,
	"input": `CGMAlertsModule-module__input___SCPbH`
};
module.exports = ___CSS_LOADER_EXPORT___;
